import React from "react";

const Footer = () => (
  <footer className="bg-light p-4 m-1 text-center">
    <p>
      Datastore provided by <a href="https://fauna.com">Fauna.</a>{" "}
      Authentication provided by <a href="https://auth0.com">Auth0</a> Hosted on{" "}
      <a href="https://www.github.com/pages">GitHub</a>
    </p>
  </footer>
);

export default Footer;
